import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatAnchor, MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatToolbar} from '@angular/material/toolbar';
import {Router, RouterLink} from '@angular/router';
import {AuthService} from '@app/auth/auth.service';
import {StorageService} from '@app/shared/storage.service';
import {User} from '@app/shared/user.service';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'frog-landing-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [
        MatToolbar,
        RouterLink,
        MatIconButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
        MatButton,
        MatAnchor,
        AsyncPipe,
    ],
})
export class ToolbarComponent implements OnInit {
    public user$: Observable<User>;
    public hosted = environment.hosted;

    constructor(
        private authService: AuthService,
        private storageService: StorageService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.user$ = this.authService.user;
    }

    login(signup: boolean) {
        this.storageService.set('signup', signup);
        this.authService.redirectToIdp();
    }

    logout() {
        this.authService.logout().subscribe();
    }
}
